export default __webpack_public_path__ + "static/media/technology.081aa29d.svg";